//
// Generated class DBCoreDocument
//

/// <reference path="DBCoreDocument_ManagedObject.ts" />

class DBCoreDocument extends DBCoreDocument_ManagedObject
{

}
